import moment, { Moment } from "moment";
import countriesData from "../data/countriesData.json";

export const textEllipsisOverflow = (text: string, maxCharacters: number) => {
  if (text.length > maxCharacters) {
    return text.substring(0, maxCharacters + 1) + "...";
  } else {
    return text;
  }
};

export const convertCurrencyToSymbol = (currency: string, locale = "en-CA") =>
  new Intl.NumberFormat(locale, { style: "currency", currency })
    .formatToParts(1)
    .find((x) => x.type === "currency")?.value;

export const getCountryCode = (countryName: string) =>
  countriesData.find((country) => country.label === countryName)
    ? countriesData?.find((country) => country.label === countryName)?.code
    : "";

export const getCountry = (coutryCode: string) =>
  countriesData.find((country) => country.code === coutryCode)
    ? countriesData?.find((country) => country.code === coutryCode)?.label
    : "";

export const getPaginRowsPerPageArr = (itemNum: number) => {
  if (itemNum <= 10) {
    return [itemNum];
  } else if (itemNum <= 25) {
    return [10, itemNum];
  } else if (itemNum <= 50) {
    return [10, 25, itemNum];
  } else if (itemNum <= 100) {
    return [10, 25, 50, itemNum];
  } else {
    return [10, 25, 50, 100, itemNum];
  }
};

export const getViewItems = (items: any[], index: number, rows: number) => {
  return items.slice(index * rows, index * rows + rows);
};

//general use get days between date sent and current date
export const getDays = (_date: string) => {
  // for now only accepts date format that begins with or is YYYY-MM-DD
  let modifiedDate: Moment;
  let currentDate = moment().format("YYYY-MM-DD");

  if (_date.includes("T")) {
    modifiedDate = moment(_date.substring(0, _date.indexOf("T")), "YYYY-MM-DD");
    return modifiedDate.diff(currentDate, "days");
  } else {
    modifiedDate = moment(_date, "YYYY-MM-DD");
    return modifiedDate.diff(currentDate, "days");
  }
};

//specific use for getting transit days in shipment and orders
export const getTransitDay = (_rate: any) => {
  if (_rate.shippingService.isSaturdayDelivery) {
    return getDays(_rate.arrivalDate);
  }

  if (_rate.transitDay) {
    return parseInt(_rate.transitDay);
  } else if (
    !_rate.transitDay &&
    _rate.arrivalDate &&
    _rate.arrivalDate !== "0001-01-01T00:00:00"
  ) {
    return getDays(_rate.arrivalDate);
  } else {
    return "Time Not Guarantee";
  }
};

export function uniqBy(a: any, key: any) {
  var seen: any = {};
  return a.filter(function (item: any) {
    var k = key(item);
    return seen.hasOwnProperty(k) ? false : (seen[k] = true);
  });
}

export function capitalizeUpperCases(str: string) {
  const words = str.split(" ");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0] + words[i].substr(1).toLowerCase();
  }

  return words.join(" ");
}

export const getNewItems = (count: number) => {
  const items = [];

  for (let i = 0; i < count; i++) {
    items.push({
      quantity: "1",
      length: "0",
      width: "0",
      height: "0",
      weight: "0",
    });
  }
  return items;
};

//call to return a bool if password does not meet validation standards
export const validatePassword = (
  firstPassword: string,
  secondPassword: string
) => {
  let isValidLength = firstPassword.length >= 8 ? true : false;
  let hasNumber = /\d/.test(firstPassword);
  let hasLowerCase = firstPassword !== firstPassword.toUpperCase();

  let hasUpperCase = firstPassword !== firstPassword.toLowerCase();
  let hasSpecialCharacter = /[@$!%*?&]/.test(firstPassword);
  let hasOnlyValidCharacters = /^[a-zA-Z0-9@$!%*?&]*$/.test(firstPassword);
  let hasNoWhiteSpaces = /\s/.test(firstPassword);
  if (
    isValidLength &&
    hasNumber &&
    hasUpperCase &&
    hasLowerCase &&
    hasSpecialCharacter &&
    hasOnlyValidCharacters &&
    !hasNoWhiteSpaces
  ) {
    return true;
  }

  return false;
};

// call to return a string that tells client what they are missing in their password
export const displayPasswordNotification = (
  firstPassword: string,
  secondPassword: string
) => {
  let isValidLength = firstPassword.length >= 8 ? true : false;
  let hasNumber = /\d/.test(firstPassword);
  let hasLowerCase = firstPassword !== firstPassword.toUpperCase();
  let hasUpperCase = firstPassword !== firstPassword.toLowerCase();
  let hasSpecialCharacter = /[@$!%*?&]/.test(firstPassword);
  let hasOnlyValidCharacters = /^[a-zA-Z0-9@$!%*?&]*$/.test(firstPassword);
  let hasNoWhiteSpaces = /\s/.test(firstPassword);

  let validLength = "Must be at least 8 characters";
  let validUpperCase = "Must have at least one uppercase character";
  let validLowerCase = "Must have at least one lowercase character";
  let validNumber = "Must have at least one number";
  let validSpChar = "Must have at least one special character: @$!%*?&";
  let validChar = "Has invalid character(s)";
  let validWS = "Cannot have any whitespaces";

  // if backend header returns error match with previous password => setShowPreviousPasswordMessage(true) else setShowPreviousPasswordMessage(false)
  if (firstPassword.length <= 0) return "";
  else if (hasNoWhiteSpaces) return validWS;
  else if (!hasOnlyValidCharacters) return validChar;
  else if (!hasUpperCase) return validUpperCase;
  else if (!hasLowerCase) return validLowerCase;
  else if (!hasNumber) return validNumber;
  else if (!hasSpecialCharacter) return validSpChar;
  else if (!isValidLength) return validLength;
  else return "";
};

export const formatPhoneNumber = (value: string) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

export const numberStringMaskInput = (str: string) => {
  if (str.match(/\./g) !== null && str.match(/\./g)!.length > 1) {
    str = str.slice(0, str.length - 1);
  }
  // eslint-disable-next-line
  return str.replace(/[^\d]/gi, "");
};
